const formatterPercentualValue = (value: number | string): string => {
  let numericValue = 0;
  if (typeof value === 'string') numericValue = parseFloat(value);
  else if (typeof value === 'number') numericValue = value;
  if (!numericValue) return '0%';
  const hasDecimal = numericValue % 1 !== 0;
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'percent',
    minimumFractionDigits: hasDecimal ? 2 : 0,
    maximumFractionDigits: hasDecimal ? 2 : 0,
  });
  return formatter.format(numericValue / 100);
};
export default formatterPercentualValue;
